export default "__VITE_ASSET__fcbcb6b7__"